import { render, staticRenderFns } from "./novaPropostaMT.vue?vue&type=template&id=8b353c22&scoped=true"
import script from "./novaPropostaMT.vue?vue&type=script&lang=js"
export * from "./novaPropostaMT.vue?vue&type=script&lang=js"
import style0 from "./novaPropostaMT.vue?vue&type=style&index=0&id=8b353c22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b353c22",
  null
  
)

export default component.exports